var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Aset"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.barangOptions,
      "label": "text",
      "placeholder": "Cari / pilih aset..."
    },
    model: {
      value: _vm.barang,
      callback: function callback($$v) {
        _vm.barang = $$v;
      },
      expression: "barang"
    }
  })], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Form penyimpanan kosong")]), _c('p', {
    staticClass: "text-muted small mb-2"
  }, [_vm.barang ? [_vm._v(" Aset dipilih: "), _c('strong', [_vm._v(_vm._s(_vm.barang.text))])] : [_vm._v(" Pilih aset di atas sebelum mengisi lokasi. ")]], 2), _c('fieldset', {
    attrs: {
      "disabled": !_vm.barang
    }
  }, [_vm.myGudang ? _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Gudang")]), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm.myGudang.nama_gudang
    }
  })], 1) : _vm._e(), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "blok",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Lokasi Aset "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('div', {
          staticClass: "d-flex align-items-start"
        }, [_c('v-select', {
          staticClass: "flex-grow-1",
          attrs: {
            "options": _vm.bloks,
            "required": !_vm.form.blok_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "placeholder": "Pilih lokasi"
          },
          model: {
            value: _vm.form.blok_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "blok_id", $$v);
            },
            expression: "form.blok_id"
          }
        }), _c('b-button', {
          staticClass: "ml-1 flex-shrink-0",
          attrs: {
            "variant": "outline-primary",
            "title": "Tambah lokasi aset"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openLokasiModal($event);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "PlusIcon"
          }
        })], 1)], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBarang($event);
      }
    }
  }, [_vm._v(" Tambah ke antrian ")])], 1)], 1)])], 1), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Antrian penyimpanan")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.addedItems.length) + " item siap disimpan ")])]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.addedItems.length
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" Simpan ")])], 1), !_vm.addedItems.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada item di antrian. Isi form lalu klik "), _c('strong', [_vm._v("Tambah ke antrian")]), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "fields": _vm.fieldsAddedItems,
      "bordered": "",
      "striped": "",
      "responsive": "",
      "items": _vm.addedItems
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
      }
    }, {
      key: "cell(lokasi)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('strong', [_vm._v(_vm._s(item.lokasi))])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(row) {
        return [_c('b-link', {
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.addedItems.splice(row.index, 1);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "24",
            "icon": "XCircleIcon"
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tambah-lokasi-aset-empty",
      "title": "Tambah Lokasi Aset",
      "centered": "",
      "ok-title": "Simpan",
      "cancel-title": "Batal"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.submitLokasi($event);
      }
    },
    model: {
      value: _vm.showLokasiModal,
      callback: function callback($$v) {
        _vm.showLokasiModal = $$v;
      },
      expression: "showLokasiModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gudang Aset"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm.myGudang ? _vm.myGudang.nama_gudang : ''
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Nama Lokasi / Blok"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nama lokasi"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.submitLokasi($event);
      }
    },
    model: {
      value: _vm.lokasiForm.blok,
      callback: function callback($$v) {
        _vm.$set(_vm.lokasiForm, "blok", $$v);
      },
      expression: "lokasiForm.blok"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }